import { useEffect, useState } from "react";
import Input from "../../../Components/Input";
import Radio from "../../../Components/Radio";
import Select from "../../../Components/Select";

const MemberModal = ({
  register,
  errors,
  control,
  dataGroup,
  dataRoles,
  watch,
  image,
}) => {
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (name === "photo_file") {
        console.log(value?.photo_file[0]);
        const objectUrl = URL.createObjectURL(value?.photo_file[0]);
        setPreview(objectUrl);
        return () => URL.revokeObjectURL(objectUrl);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    if (image) {
      setPreview(process.env?.REACT_APP_FILE_URL + "/" + image);
    }
  }, [image]);

  return (
    <>
      <div className="mb-5">
        <label htmlFor="name" className="block mb-3">
          Full Name <span className="text-red-500">*</span>
        </label>
        <Input
          id="name"
          placeholder="Input Full Name"
          required
          type="text"
          {...register("name")}
          errors={errors?.name?.message}
        />
      </div>

      <div className="mb-5">
        <label htmlFor="email" className="block mb-3">
          Email <span className="text-red-500">*</span>
        </label>
        <Input
          id="email"
          placeholder="Input Email"
          required
          type="text"
          {...register("email")}
          errors={errors?.email?.message}
        />
      </div>

      <div className="mb-5">
        <label htmlFor="phone_number" className="block mb-3">
          Phone Number <span className="text-red-500">*</span>
        </label>
        <Input
          id="phone_number"
          placeholder="Input Phone Number"
          required
          type="number"
          {...register("phone_number")}
          numberOnly
          errors={errors?.phone_number?.message}
        />
      </div>

      <div className="mb-5">
        <label htmlFor="password" className="block mb-3">
          Password <span className="text-red-500">*</span>
        </label>
        <Input
          id="password"
          placeholder="Input Password"
          required
          type="password"
          {...register("password")}
          errors={errors?.password?.message}
        />
      </div>

      <div className="mb-5">
        <label htmlFor="m_groups_id" className="block mb-3">
          Group <span className="text-red-500">*</span>
        </label>
        <Select control={control} id="m_groups_id" data={dataGroup} />
      </div>

      <div className="mb-5">
        <label htmlFor="m_roles_id" className="block mb-3">
          Role <span className="text-red-500">*</span>
        </label>
        <Select control={control} id="m_roles_id" data={dataRoles} />
      </div>

      <div className="mb-5">
        <label htmlFor="status" className="block mb-3">
          Status <span className="text-red-500">*</span>
        </label>

        <div className="flex">
          <Radio
            id="status"
            label="Active"
            value="1"
            name="status"
            required
            {...register("status")}
          />
          <Radio
            id="status-2"
            label="Non Active"
            value="0"
            name="status"
            required
            {...register("status")}
          />
        </div>

        <small className="text-[red]">{errors.status?.message}</small>
      </div>

      <div className="mb-5 flex">
        <div className="w-full">
          <label htmlFor="photo_file" className="block mb-3">
            Photo Profile
          </label>
          <input
            type="file"
            id="photo_file"
            className="form-control"
            {...register("photo_file")}
            accept="image/*"
          />
          <small className="text-danger">{errors.photo_file?.message}</small>
        </div>
        {preview && (
          <img
            alt=""
            src={preview}
            className="h-[120px] w-[120px] rounded-full object-cover"
          />
        )}
      </div>
    </>
  );
};

export default MemberModal;
